import React from 'react';

import Row from '@amzn/meridian/row';
import Tag from '@amzn/meridian/tag';

import './appliedFilterTags.scss';

export interface FilterTag<T extends object> {
  prefix: string;
  value: string | number;
  optionName: keyof T;
}

interface AppliedFilterTagsProps<T extends object> {
  filterTags: FilterTag<T>[];
  onDismissTag: (tag: FilterTag<T>) => void;
  'tag-data-testid'?: string;
}

const AppliedFilterTags = <T extends object>(props: AppliedFilterTagsProps<T>) => {
  const { filterTags, onDismissTag, 'tag-data-testid': tagDataTestId } = props;
  return filterTags.length ? (
    <Row wrap="down" className="applied-filter-tags">
      {filterTags.map((filterTag) => (
        <Tag
          onClose={() => onDismissTag(filterTag)}
          type="theme"
          key={`${filterTag.prefix}${filterTag.value}`}
          data-testid={tagDataTestId ?? 'applied-filter-tag'}
        >
          {`${filterTag.prefix}${filterTag.value}`}
        </Tag>
      ))}
    </Row>
  ) : (
    <></>
  );
};

export default AppliedFilterTags;
